import { render, staticRenderFns } from "./ui-badge-component.vue?vue&type=template&id=5382a44c&scoped=true&"
import script from "./ui-badge-component.vue?vue&type=script&lang=ts&"
export * from "./ui-badge-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-badge-component.vue?vue&type=style&index=0&id=5382a44c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382a44c",
  null
  
)

export default component.exports